import { render, staticRenderFns } from "./VFolder.vue?vue&type=template&id=e60bf95a&"
import script from "./VFolder.vue?vue&type=script&lang=ts&"
export * from "./VFolder.vue?vue&type=script&lang=ts&"
import style0 from "./VFolder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports